/* nl-pick-popup — a once-per-session "pick a box to reveal the offer" popup.

   Root:     [data-nl-popup]  (a dialog overlay)
             data-nl-session-key="lx06pop"   sessionStorage key that stores "shown"
             data-nl-scroll="0.45"           share of page scrolled that opens it (default 0.45)
             data-nl-exit-min="1024"         from this width, also open on exit intent (default 1024; 0 = off)
   Children: [data-nl-popup-close]           close buttons
             [data-nl-popup-box]             boxes; data-nl-open-label = text the picked box shows
             [data-nl-popup-reveal]          block shown after a box is picked
   State:    overlay gets nl-is-open; reveal gets nl-is-shown.
   Never auto-opens inside the theme editor (Shopify.designMode).
   Lifecycle: re-inits on shopify:section:load, tears down on :unload. */
(function () {
  var instances = {};

  function init(pop) {
    if (!pop || pop.__nlPop) return;
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var key = pop.getAttribute('data-nl-session-key') || 'nlpop';
    var scrollAt = parseFloat(pop.getAttribute('data-nl-scroll'));
    if (isNaN(scrollAt)) scrollAt = 0.45;
    var exitMin = parseInt(pop.getAttribute('data-nl-exit-min'), 10);
    if (isNaN(exitMin)) exitMin = 1024;
    var section = pop.closest('[id^="shopify-section-"]');
    var shown = false;
    try { shown = sessionStorage.getItem(key) === '1'; } catch (e) {}
    var cleanups = [];
    function on(el, type, fn, opts) {
      if (!el) return;
      el.addEventListener(type, fn, opts);
      cleanups.push(function () { el.removeEventListener(type, fn, opts); });
    }

    function open() {
      if (shown || designMode) return;
      shown = true;
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      pop.classList.add('nl-is-open');
    }
    function close() { pop.classList.remove('nl-is-open'); }

    on(pop, 'click', function (e) { if (e.target === pop) close(); });
    [].forEach.call(pop.querySelectorAll('[data-nl-popup-close]'), function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });

    var boxes = [].slice.call(pop.querySelectorAll('[data-nl-popup-box]'));
    var reveal = pop.querySelector('[data-nl-popup-reveal]');
    boxes.forEach(function (b) {
      on(b, 'click', function () {
        boxes.forEach(function (x) { x.disabled = true; });
        b.classList.add('nl-is-picked');
        var label = b.getAttribute('data-nl-open-label');
        if (label) b.textContent = label;
        if (reveal) reveal.classList.add('nl-is-shown');
      });
    });

    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > scrollAt) open();
    }
    on(window, 'scroll', onScroll, { passive: true });
    on(document, 'mouseout', function (e) {
      if (exitMin && window.innerWidth >= exitMin && !e.relatedTarget && e.clientY < 8) open();
    });

    pop.__nlPop = true;
    instances[section ? section.id : 'x'] = function () {
      cleanups.forEach(function (fn) { fn(); });
      delete pop.__nlPop;
    };
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-nl-popup]'), init);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var k = e.target.id || 'x';
    if (instances[k]) { instances[k](); delete instances[k]; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
